// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"d3d47080","595":"33f8609b","628":"3ad81daf"}[chunkId] + ".chunk.js";
};